import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const getEndpoints = createAsyncThunk('endpointsSlice/getEndpoints', async () => {
  const response = await axios.get(`EndPoints/getendpoints`);
  return response.data;
});

export const getSingleEndPoint = createAsyncThunk('endpointsSlice/getSingleEndPoint', async (id) => {
  const response = await axios.get(`EndPoints/${id}`);
  return { status: response.status, data: response.data };
});

export const createEndpoint = createAsyncThunk('endpointsSlice/createEndpoint', async (values) => {
  try {
    const response = await axios.post(`EndPoints/createendpoint`, values, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});
export const updateEndpoint = createAsyncThunk('endpointsSlice/updateEndpoint', async (values) => {
  try {
    const response = await axios.put(`EndPoints/updateendpoint?id=${values.id}`, values.formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});
export const deleteEndpoint = createAsyncThunk('endpointsSlice/deleteEndpoint', async (id) => {
  try {
    const response = await axios.delete(`EndPoints/deleteendpoint?id=${id}`);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { data: error.response.data, status: error.response.status };
  }
});

const initialState = {
  loading: false,
  endpointData: null,
};

const endpointsSlice = createSlice({
  name: 'endpoints',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEndpoints.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getEndpoints.fulfilled, (state, action) => {
        state.loading = false;
        state.endpointData = action.payload;
      });
  },
});

export default endpointsSlice.reducer;
